var map = {
	"./Card(0)-ch.png": 54578,
	"./Card(0)-en.png": 76098,
	"./Card(1)-ch.png": 17415,
	"./Card(1)-en.png": 42483,
	"./Card(2)-ch.png": 87576,
	"./Card(2)-en.png": 38136,
	"./Card(3)-ch.png": 8053,
	"./Card(3)-en.png": 76929,
	"./Card(4)-ch.png": 30670,
	"./Card(4)-en.png": 89134
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 88926;